import type { KieModelConfig, StatusMapping } from './types';
import { openaiConfigs } from './configs/openai';
import { googleConfigs } from './configs/google';
import { bytedanceConfigs } from './configs/bytedance';
import { qwenConfigs } from './configs/qwen';
import { recraftConfigs } from './configs/recraft';
import { topazConfigs } from './configs/topaz';
import { wrappedConfigs } from './configs/wrapped';
import { xaiConfigs } from './configs/xai';

export const kieApiPaths = {
    /** 创建任务 API 路径 */
    createTask: '/api/v1/jobs/createTask',
    /** 轮询任务 API 路径 */
    pollTask: '/api/v1/jobs/recordInfo',
};

export const kieStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'data.taskId',
    /** 状态字段路径 */
    statePath: 'data.state',
    /** 成功状态值 */
    success: ['success'],
    /** 失败状态值 */
    failed: ['fail'],
    /** 处理中状态值 */
    processing: ['generating', 'waiting', 'processing'],
    /** 图像 URL 字段路径 */
    imageUrlPath: 'data.resultJson',
    /** 错误信息字段路径 */
    errorPath: 'data.failMsg',
};

export const kieModelConfigs: Record<string, KieModelConfig> = {
    ...openaiConfigs,
    ...googleConfigs,
    ...bytedanceConfigs,
    ...qwenConfigs,
    ...recraftConfigs,
    ...topazConfigs,
    ...wrappedConfigs,
    ...xaiConfigs,
};